import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-classmaterial',
  templateUrl: './classmaterial.component.html',
  styleUrls: ['./classmaterial.component.css']
})
export class ClassmaterialComponent implements OnInit {
  @Input() file: any;
  @Input() adminuser:any;
  @Output() deletefile: EventEmitter<any> = new EventEmitter();
  confirmDelete:boolean=false;

  constructor() { }

  ngOnInit(): void {
  }

  deleteconfimed(fileid: number) {
    this.deletefile.emit(fileid);
  }

  popconfirmdelete(show:number)
  {
    if(show==1)
    {
      this.confirmDelete=true;
    }
    else if(show==0)
    {
      this.confirmDelete=false;
    }
  }
}
